import { Chips } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import './PositionLineContainer.scss';

const PositionLineContainer = ({
  positionLine,
  setValues,
  values,
  deletePositionLineVE,
  extendedView
}) => {
  const hasData = positionLine?.length;

  const deletePositionLine = (labelValue) => {
    const newValues = positionLine?.filter((e) => e?.label !== labelValue);

    setValues({
      ...values,
      posicionesLineas: newValues
    });
  };

  return (
    <div className={`position-line-container${hasData ? '' : '-disabled'}`}>
      {hasData ? (
        <Chips
          data={positionLine}
          onDelete={
            extendedView
              ? (chip) => deletePositionLineVE(chip)
              : (chip) => deletePositionLine(chip.label)
          }
          variant="dark"
        />
      ) : (
        <p className="place-holder">Posición y linea</p>
      )}
    </div>
  );
};

export default PositionLineContainer;

PositionLineContainer.propTypes = {
  positionLine: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ).isRequired,
  setValues: PropTypes.func.isRequired, // Add this line
  values: PropTypes.shape({}).isRequired, // Also add a validation for the 'values' prop,
  deletePositionLineVE: PropTypes.func,
  extendedView: PropTypes.bool
};

PositionLineContainer.defaultProps = {
  deletePositionLineVE: () => {},
  extendedView: false
};
